import React from "react";
import Maps from "../Maps/mapsContact";
import address from "../../assets/map-location-solid (1).svg"
import phone from "../../assets/phone-solid (1).svg"
import whatsapp from "../../assets/whatsapp (1).svg"
import email from "../../assets/envelope-regular (1).svg"
import './contact.css'
import MapComponent from "../Maps/mapsContact";

function getPreview({avatar_url, name,login,html_url,email,company}) {
    return ` 
    <div class="contentGit">
      <img src="${avatar_url}" class='avatar' alt="${name}" />
      <div>
        <h4>${name}</h4>
        <p>${login}<p/>
        <p>Email :${email ? email: 'nzitapuindi2@gmail.com'}<p/>
        <p>Travail a :${company ? company: 'Kollectif Numerique'}</p>
        <p>Mon Github en cliquand ici <br/> <a href="${html_url}">Dash</a><p/>
      </div>
    </div>`;
}
function Contact (){
   (function Gitcontent(){ 
    let gitinfo ;
    const url = `https://api.github.com/users/dash-dev-5`;
      fetch(url)
        .then((res) => {
          if (res.status === 200) {
            return res.json();
          }
        })
        .then( (res) => {
            gitinfo=res
            console.log(res)

          document.querySelector('.linkContact').innerHTML= getPreview(res)    
        })
        .catch((e) => {
            console.error('error fetsh')
        });
     
      
    })()
    return <div className="bg-contact">
        <div className="viewContact">
            <div className="divs">
            <div className="addressContact">
                <img src={address} alt="address"  />
                <h4>NOTRE BUREAU PRINCIPALE</h4>
                <p>Av.Ruphin Kisilu N°40</p>
            </div>
            <div className="phoneContact">
                <img src={phone} alt="phone" />
                <h4>NUMERO TELEPHONE</h4>
                <p>+243 892 669 552</p>
            </div>
                
            </div>
            <div className="divs">

            <div className="whatsappContact">
                <img src={whatsapp} alt="whatsapp"  />
                <h4>NUMERO WHATSAPP</h4>
                <p>+243 892 669 552</p>
            </div>
            <div className="emailContact">
                <img src={email} alt="email" />
                <h4>E-MAIL</h4>
                <p>nzitapuindi2 @gmail.com</p>
            </div>

            </div>
        </div>
        <div className="submitContact">
            <div className="form">
                <form action="" className="formCorrespondant">
                    <input type="text" name="nameCorrespondant" id="nameCorespondant" placeholder="Votre nom" />
                    <input type="email" name="emailCorrespondant" id="emailCorrespondant" placeholder="Votre email"/>
                    <textarea name="messageCorrespondant" id="messageCorrespondant" cols="30" rows="10" placeholder="Votre message"></textarea>
                    <button type="submit">Envoyer</button>
                </form>
            </div>
            <div >
                <div className="linkContact">
                    
                </div>
                <div className="contentLink">
                    <h3>Nous contacter</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis expedita nesciunt, omnis odio quos in, nihil consequatur ipsa ab vero necessitatibus voluptate .</p> 

                </div>
            </div>
        </div>
        <div className="maps">
            <MapComponent lattitude={-5.847278} longitude={ 13.446038}/>
        </div>
    </div>
}

export default Contact